import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import { HttpStatusCode } from 'axios';
import config from '../../../config/config';
import axiosInstance from '../../../config/interceptors/axios.interceptor';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import Sidebar from '../Sidebar/Sidebar';
import styles from './LandingLayout.module.scss';

interface LayoutProps {
  showHeader?: boolean;
  showNavigation?: boolean;
  user?: string;
}

const LandingLayout: React.FC<LayoutProps> = ({
  showHeader = false,
  showNavigation = false,
  user = '',
}) => {
  const [loggedUser, setLoggedUser] = useState('');

  useEffect(() => {
    const getActiveUsername = () => {
      let username = '';
      const nativeId = localStorage.getItem('auth-nativeId');
      if (nativeId) {
        const url = `${config.appUrl}/auth/user/native/${nativeId}`;
        axiosInstance
          .get(url)
          .then((res) => {
            if (res && res.data && res.data.statusCode === HttpStatusCode.Ok && res.data.body) {
              setLoggedUser(res.data.body.fullName);
            }
          })
          .catch((err) => {
            console.log(`Get user by native id: ${nativeId} error: ${err}`);
          });
      }

      return username;
    };

    getActiveUsername();
  }, []);

  return (
    <div className={styles.root}>
      <Header showNavigation={showNavigation} showHeader={showHeader} loggedUser={loggedUser} />
      <div className={styles.container}>
        <div className={styles.sidebar}>
          <Sidebar />
        </div>
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LandingLayout;
